import {TXY, getBuoys, TGetBuoysResponse} from "@ui/api/features"
import service from "@ui/services/features/BuoyService"
import {LayerId} from "@ui/services/features"
import {Feature, TFeatureConstructorParams} from "./feature"

type TBuoyConstructorParams = TFeatureConstructorParams

export class Buoy extends Feature {

  constructor(params: TBuoyConstructorParams) {
    super(params)
  }

  async load(coords: TXY): Promise<void> {
    const buoys = await getBuoys(coords)
    for (const type in buoys) {
      service.addBuoys(buoys[type as keyof TGetBuoysResponse], `buoy_${type}` as LayerId)
    }
  }

  toggle(isVisible: boolean) {
    service.toggleLayer(isVisible)
  }
}
